import Immutable = require('immutable')
import React = require('react')

import { FormGroup } from './FormGroup'
import { DetailsFormData } from './models'
import { AsyncPost, AsyncPostStatus, Dictionary } from './utils'
import { validateDetailsFormData } from './validation'

declare var ga;
declare const $

interface Properties {
    postData: AsyncPost<any,any>
}

interface Callbacks {
    onSubmit: (formData: DetailsFormData) => void    // Triggered when the user submits the form & data pass validation checks
}

interface Props extends Properties, Callbacks {}

interface State {
    validationErrors: Dictionary<string[]>
}

export class DetailsForm extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            validationErrors: {}
        }
    }

    handleSubmit(event) {

        event.preventDefault();

        if (this.props.postData.status == AsyncPostStatus.POSTING) {
            // The form is currently being posted so we don't do anything
            return;
        }

        var formData = Immutable.List( $(this.refs["form"]).serializeArray() )
            .reduce( (map, obj: any) => map.set(obj.name, obj.value), Immutable.Map() )
            .toJS();

        var errors = validateDetailsFormData(formData);

        this.setState({
            validationErrors: errors
        });

        if (Immutable.Map(errors).size > 0) {
            ga('send', 'event', 'Wizard', 'details-form-validation-error');
            // There are some validation errors so we don't proceed
        } else {
            this.props.onSubmit(formData);
        }

    }

    render() {

        var submitButton;
        if (this.props.postData.status == AsyncPostStatus.POSTING) {
            submitButton = <button type="submit" className="cc-contact-form__submit-btn btn btn-success btn-lg btn-cc-green disabled" onClick={this.handleSubmit.bind(this)}>Submitting ...</button>
        } else {
            submitButton = <button type="submit" className="cc-contact-form__submit-btn btn btn-success btn-lg btn-cc-green" onClick={this.handleSubmit.bind(this)}>Get instant quote</button>
        }

        return <div className="cc-details-form">
            <form ref="form">
                <div className="row">
                    <div className="cc-details-form__left-side col-xs-12">

                        <FormGroup errors={this.state.validationErrors['name']}>
                            <label htmlFor="inputName">Name</label>
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                id="inputName"
                                placeholder="Name"
                            />
                        </FormGroup>

                        <FormGroup errors={this.state.validationErrors['surname']}>
                            <label htmlFor="inputSurname">Surname</label>
                            <input
                                type="text"
                                name="surname"
                                className="form-control"
                                id="inputSurname"
                                placeholder="Surname"
                            />
                        </FormGroup>

                        <FormGroup errors={this.state.validationErrors['email']}>
                            <label htmlFor="inputEmail">Email Address</label>
                            <input
                                type="email"
                                name="email"
                                className="form-control"
                                id="inputEmail"
                                placeholder="Email Address"
                            />
                        </FormGroup>

                        <FormGroup errors={this.state.validationErrors['phone']}>
                            <label htmlFor="inputContactNumber">Phone</label>
                            <input
                                type="text"
                                name="contactNumber"
                                className="form-control col-xs-8"
                                id="inputContactNumber"
                                placeholder="Contact Number"
                            />
                            {/*<div className="row">
                                <div className="col-xs-4 col-padding-right-sm">
                                    <input type="text" name="areaCode" className="form-control col-xs-4" id="inputAreaCode" placeholder="Area Code" />
                                </div>
                                <div className="col-xs-8 col-padding-left-sm">
                                    <input type="text" name="contactNumber" className="form-control col-xs-8" id="inputContactNumber" placeholder="Contact Number" />
                                </div>
                            </div>*/}
                        </FormGroup>

                    </div>

                </div>

                <div className="row">
                    <div className="col-xs-12 text-center">
                        {submitButton}
                    </div>
                </div>
            </form>

        </div>;
    }
}
